<template>
    <div v-if="this.user.role == 'Admin'" class="admin-page max-w-screen overflow-x-hidden">
        <HeaderComponent />
        <div class="flex" :class="this.$route.name == 'admin-dashboard' ? 'justify-center' : '' ">
            <SidebarComponent class="hidden md:block" v-if="this.$route.name != 'admin-dashboard'" />
            <main class="container">
                <router-view></router-view>
            </main>
        </div>
        <ApprovalModalComponent @approval="handleSubmissionApproval" :isLoading="isLoading"
                                :hasError="hasApplicationError" @close="showHideApprovalModal" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HeaderComponent from "@adminComponents/partials/HeaderComponent";
import SidebarComponent from "@adminComponents/partials/SidebarComponent";
import ApprovalModalComponent from "@adminComponents/modals/ApprovalModalComponent";

export default {
    name: "AdminApp",
    props: {},
    components: {
        HeaderComponent,
        SidebarComponent,
        ApprovalModalComponent,
    },
    data() {
        return {
            isLoading: false,
            hasApplicationError: false,
        };
    },
    computed: {
        ...mapGetters(["global", "user"]),
    },
    methods: {
        ...mapActions(["doGetUser", "doLogout", "doGetCollectionData", "doUpdateSubmissionStatus", "showHideApprovalModal"]),
        getUserFromSession() {
            if (this.user != undefined && this.user.role != "Admin") {
                this.doLogout().then((response) => {
                    let loginUrl = this.$router.resolve({
                        name: "login",
                    });
                    window.location.replace(loginUrl.href);
                });
            }
            if (this.user.access_token && this.user.id && this.$route.name != "email-not-verified") {
                // If the previous access token has persisted in the Vuex store, let's set that token as the bearer token in Axios
                // @todo: call the user endpoint to ensure that the current user's details are up to date
                this.doGetUser(this.user.id);
            }
        },
        setAxiosBearerToken() {
            if (this.user.access_token) {
                axios.defaults.headers.common["Authorization"] = "Bearer " + this.user.access_token;
            }
        },
        handleSubmissionApproval(event) {
            this.hasApplicationError = false;
            this.isLoading = true;

            let payload = {};
            payload.status = event.approvalType;

            if (event.reason) payload.reason = event.reason; // Add the "reason" if required

            this.doUpdateSubmissionStatus(payload).then((response) => {
                this.isLoading = false;
                this.showHideApprovalModal();
                if (payload.status === "Deleted") {
                    // redirect to admin dashboard
                    this.$router.push({ name: "admin-dashboard" });
                }
            }, (error) => {
                this.isLoading = false;
                this.hasApplicationError = true;
            });
        },
    },
    beforeMount() {
        this.setAxiosBearerToken(); // Set the bearer token in Axios
        this.getUserFromSession();
        this.doGetCollectionData("countries");
    },
    watch: {},
};
</script>
